import axios from '@/axios'

class CompanyDataService {
  async getAllCompanies(page: number, sortBy = 'id', sortOrder = 'desc', search = ''): Promise<any> {
    const params = new URLSearchParams({ page: String(page), sort_by: sortBy, sort_order: sortOrder })
    if (search) params.set('search', search)
    return axios.get(`/companies/getAllCompanies?${params.toString()}`)
  }
  async getAllCompaniesForUser(user_id: any): Promise<any> {
    return axios.get(`/companies/${user_id}/getAll`)
  }  async getCompanyById(id: any): Promise<any> {
    return axios.get(`/companies/${id}/get`)
  }
  async getRenewalBillingProfile(id: any, service: 'vhq' | 'documents'): Promise<any> {
    return axios.get(`/companies/${id}/renewal-billing/${service}`)
  }
  async add(data: any): Promise<any> {
    return axios.post('/companies/add', data)
  }
  async update(id: any, data: any): Promise<any> {
    return axios.put(`/companies/${id}/update`, data)
  }
  async delete(id: any): Promise<any> {
    return axios.delete(`/companies/${id}/delete`)
  }
  async getCompanyTypes(): Promise<any> {
    return axios.get('/companies/getCompanyTypes')
  }
  async getCompanyStatuses(): Promise<any> {
    return axios.get('/companies/getCompanyStatuses')
  }
  async getCompanySubStatuses(): Promise<any> {
    return axios.get('/companies/getCompanySubStatuses')
  }
  async getKonecnyUzivateliaVyhod(): Promise<any> {
    return axios.get('/companies/getKonecnyUzivateliaVyhod')
  }
  async getSposobyKonaniaKonatelov(): Promise<any> {
    return axios.get('/companies/getSposobyKonaniaKonatelov')
  }
  async searchCompanies(searchTerm: string): Promise<any> {
    return axios.get(`/companies/getAllCompanies?search=${encodeURIComponent(searchTerm)}`)
  }
}
export default new CompanyDataService()